import { MarketplacePricingTierType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { RemoteAgentTierGrid } from '../RemoteAgentPricing';
import { ServerDCTiersGrid } from '../ServerDCPricing';
import { jsx as _jsx } from "react/jsx-runtime";
const PricingGrid = props => {
  const {
    tierType,
    currency,
    items
  } = props;
  if (tierType === MarketplacePricingTierType.RemoteAgentTiered) {
    return /*#__PURE__*/_jsx(RemoteAgentTierGrid, {
      items: items,
      currency: currency
    });
  }

  // other tiers => UserAgentTiered, Cloud hosting displays Pricing calculator
  return /*#__PURE__*/_jsx(ServerDCTiersGrid, {
    items: items,
    currency: currency
  });
};
export default PricingGrid;